import { ScrollView, Text } from 'react-native'
import theme from '../../../../theme'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
export const TermsAndConditionsDetailScreen = ({ route }) => {
    const { text } = route?.params ?? ''
    const insets = useSafeAreaInsets()
    return (
        <ScrollView
            style={{ marginHorizontal: 12, flex: 1 }}
            contentInset={{ bottom: insets.bottom, top: 8 }}
        >
            <Text
                style={{
                    fontSize: 15,
                    color: theme.colors.darkGray,
                    lineHeight: 19.5,
                }}
            >
                {text}
            </Text>
        </ScrollView>
    )
}
